import { CommonTableColumnsEnum } from '../../components/Table/types'
import { PagePagination, SortDirectionCapital } from '../../types'

export enum TradeStatus {
  win = 'win',
  loss = 'loss',
  open = 'open',
}

export type TradeType = 'long' | 'short'

export interface Trade {
  priceCurrency: string
  [CommonTableColumnsEnum.id]: string
  [CommonTableColumnsEnum.createdAt]: string
  [CommonTableColumnsEnum.ticket]: number
  [CommonTableColumnsEnum.openTime]: string
  [CommonTableColumnsEnum.closeTime]: string
  [CommonTableColumnsEnum.symbol]: string
  [CommonTableColumnsEnum.status]: TradeStatus
  [CommonTableColumnsEnum.type]: TradeType
  [CommonTableColumnsEnum.volume]: number
  [CommonTableColumnsEnum.lots]: string
  [CommonTableColumnsEnum.openPrice]: string
  [CommonTableColumnsEnum.closePrice]: string
  [CommonTableColumnsEnum.grossProfit]: string
  [CommonTableColumnsEnum.netProfit]: string
  [CommonTableColumnsEnum.roi]: string
  [CommonTableColumnsEnum.transactionStatus]: string
  [CommonTableColumnsEnum.journalingCompletion]: string
  [CommonTableColumnsEnum.riskLevel]: string
  [CommonTableColumnsEnum.commissions]: string
  [CommonTableColumnsEnum.fee]: string
  [CommonTableColumnsEnum.swap]: string
  tradeAiAnalysis?: TradeAiAnalysis | null
}

export type TradingLogRequestType = {
  page: number
  perPage: number
  columns: (keyof Trade)[]
  period: string[] | null[]
  account: number
  order: SortDirectionCapital
  orderBy: keyof Trade | null
  fromCalendar: boolean
}

export interface TradingLogData {
  data: Trade[]
  meta: PagePagination<Trade>
}

export type TradingLogAllTradesResponse = {
  [CommonTableColumnsEnum.id]: number
  [CommonTableColumnsEnum.journalingCompletion]: number
}[]

export interface TradingLogInitialState {
  trades: Trade[]
  pagination: PagePagination<Trade>
  selectedAll: boolean
  selectedTrades: TradingLogAllTradesResponse
  massFillEnabled: boolean
}

export type OverrideQuestionnaire = {
  open: boolean
  onClose: () => void
}

export interface TradeAiAnalysisReferenceType {
  title: string
  url: string
}

export interface TradeAiAnalysis {
  summary: string
  tags: string[]
  references: TradeAiAnalysisReferenceType[]
  keyFactor?: string
  recommendation?: string
  generatedAt: string
}

export interface TradeAiAnalysisRequestParams {
  regenerate?: boolean
  language?: string
}
